import { useContext, useEffect, useRef, useState } from "react";
import { useRouteMatch } from "react-router-dom";

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { MenuItem, MenuList } from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Scroll from 'react-scroll';
import { MobiOrNotContext, OrderContext } from "../../ContextApi/context";
import MyDateTime from "../../DTechComp/MyDateTime";
import ProductItem from "./ProductItem";
import ProductItemDeskTop from "./ProductItemDeskTop";
import BuisRating from "./RestDetails/BuisRating";
import DayOpeningHours from "./RestDetails/DayOpeningHours";
import AddressLine from "./RestDetails/addressLine";
import myFunctions, { getPhoneDisplay } from "../../myFunctions";
import PhoneLink from "../../DTechComp/PhoneLink";
import parse from 'html-react-parser';

var scroller = Scroll.scroller;


const isBot = /bot|googlebot|crawler|spider/i.test(navigator.userAgent);

const LazyProductList = ({ products, preload }) => {
    const ref = useRef(null);
    const [loaded, setLoaded] = useState(preload || isBot);

    useEffect(() => {
        if (loaded) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setLoaded(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "400px" }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [loaded]);

    return (
        <div ref={ref} className={`divBlock${loaded ? "" : " lazyPlaceholder"}`}>
            {loaded ? products : null}
        </div>
    );
};


const RestMnu = (props) => {
    let { path, url } = useRouteMatch();
    const [currP] = useState(props.restPage);
    const [order, setOrder] = useContext(OrderContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [value, setValue] = useState(0);
    const [sender, setSender] = useState(null);

    const RestMnuRef = useRef(0);
    const searchBarRef = useRef(null);
    const [restMnuFxClass, setRestMnuFxClass] = useState("noFix");
    //גובה הראש הקבוע (inMast, position:fixed בדסקטופ) - נמדד בפועל ולא
    //קבוע קשיח, כדי שתפריט הקטגוריות ושורת החיפוש ידבקו בדיוק מתחתיו
    //כשהופכים fixed
    const [headerHeight, setHeaderHeight] = useState(0);
    //ברגע ש-BottomMast נכנס לתצוגה (+200px), במקום לחזור ל-relative (מה
    //שגורם לאלמנט "לקפוץ" למיקום הסטטי שלו בראש התפריט, רחוק מעיני
    //המשתמש) - עוברים ל-absolute עם top קפוא בדיוק במקום שבו ה-fixed
    //הפסיק, כך שהאלמנט "נעצר" חלק בדיוק מעל BottomMast בלי קפיצה חזותית
    const [frozenTop, setFrozenTop] = useState(null);
    const searchTimeoutRef = useRef(null);
    const [restMnuSpClass, setRestMnuSpClass] = useState("");

    const [mnuDivsPadd, setMnuDivsPadd] = useState("noPadd");

    const [searchTxt, setSearchTxt] = useState("");
    const [shHidMoreDetails, setShHidMoreDetails] = useState(false);

    const [onlyPhone, setOnlyPhone] = useState();

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        if (!mobiOrNot) {
            const inMastEl = window.document.getElementsByClassName("inMast")[0];
            if (inMastEl) setHeaderHeight(inMastEl.offsetHeight);
        }

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        //ה-props כבר נושאים את האמת התלת-ערוצית מ-RestaurantPage.
        //בדיקת שעות הפתיחה שהייתה כאן הוסרה - שעות פתיחה
        //אינן חוסמות הזמנות יותר
        if (!props.doDeliver && !props.doTakeAway) {
            setOnlyPhone(true);
        }

    }, []);

    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);


    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        let bottomMastPos = "";
        try {
            bottomMastPos = window.document.getElementsByClassName("BottomMast")[0].offsetTop;
        }
        catch {
            bottomMastPos = 0;
        }

        //תפריט הקטגוריות ושורת החיפוש הם שני אלמנטים עצמאיים (position:fixed
        //נפרד לכל אחד, עם right/left מפורשים משלו ב-CSS), אבל שניהם
        //מקבלים את אותו קלאס fixPos/noFix/absPos כדי לעבור מצב באותו רגע
        //בדיוק ולהישאר זה-לצד-זה.
        //בלי גבול עליון, הם ממשיכים "לגלוש" fixed גם אחרי סוף התפריט
        //ומכסים את BottomMast (הבאנרים/פוטר בתחתית העמוד). BottomMast
        //"נכנס למסך" כש-offsetTop שלו מגיע לתחתית חלון התצוגה
        //(currentScrollY + innerHeight); מוסיפים עוד 200px כדי שהמעבר לא
        //יקרה מוקדם מדי ויתחוש קפיצתי
        if (RestMnuRef.current) {
            const pastBottomMast = bottomMastPos && (currentScrollY + window.innerHeight) > bottomMastPos + 200;
            const withinMenu = currentScrollY > RestMnuRef.current.offsetTop - 150;

            if (withinMenu && !pastBottomMast) {
                setRestMnuFxClass("fixPos");
                setRestMnuSpClass(mobiOrNot ? "PaddMeFix_NoSuper" : "PaddMeFix");
                // setMnuDivsPadd("withPadd");
                setFrozenTop(null);
            }
            else if (withinMenu && pastBottomMast) {
                //עוברים ל-absolute רק פעם אחת, ברגע המעבר - "קופאים" בדיוק
                //במקום שבו ה-fixed נעצר (currentScrollY + headerHeight),
                //כדי שהמעבר יהיה חלק ובלי קפיצה
                setRestMnuFxClass("absPos");
                setRestMnuSpClass(mobiOrNot ? "PaddMeFix_NoSuper" : "PaddMeFix");
                setFrozenTop(prev => prev !== null ? prev : currentScrollY + headerHeight);
            }
            else {
                setRestMnuFxClass("noFix");
                setRestMnuSpClass("");
                setMnuDivsPadd("noPadd");
                setFrozenTop(null);
            }

            spyTheBlock(currentScrollY, RestMnuRef.current.offsetTop - 100);
        }
    };

    const spyTheBlock = (currentScrollY, startMnus) => {
        let alldivBlocks = window.document.getElementsByClassName("divBlock");

        if (startMnus < currentScrollY) {
            for (let i = 0; i < alldivBlocks.length; i++) {
                const element = alldivBlocks[i];
                if (currentScrollY < element.offsetTop + element.offsetHeight - 150) {
                    setValue(i);
                    break;
                }
            }
        }
    };


    const handleChange = (newValue) => {
        setValue(newValue);
        scroller.scrollTo(`divBlock_${newValue}`, { smooth: true, offset: -140, duration: 1000 });
    };


    const handlebackToPos = (theID) => {
        scroller.scrollTo(`${theID}`, { smooth: true, offset: -100, duration: 1000 });
    };

    const serachMnuItm = (txtSearch) => {
        setSearchTxt(txtSearch);
    };


    let onlyPhoneOrders = (currP.buissIsOnline != null && currP.buissIsOnline) ? "" : "כרגע, הזמנות טלפונית";

    //מחשב את ה-style עבור התפריט/חיפוש הקבועים לפי restMnuFxClass -
    //fixPos: מוצמד לראש המסך (top=headerHeight, viewport-relative).
    //absPos: קפוא במקום שבו ה-fixed נעצר (top=frozenTop, document-relative)
    //כדי שלא "יקפוץ" בחזרה למיקום הסטטי שלו כשעוברים ל-BottomMast
    const getFixedElementStyle = () => {
        if (restMnuFxClass === "fixPos") return { top: headerHeight };
        if (restMnuFxClass === "absPos" && frozenTop !== null) return { top: frozenTop };
        return undefined;
    };


    return (

        <div className="RestMnu" ref={RestMnuRef} >

            {/* טאבים ימין + שורת חיפוש בדסקטופ - שני אלמנטים נפרדים, כל אחד
                עם position:fixed עצמאי משלו, אבל שניהם נשלטים ע"י אותו
                restMnuFxClass כדי שיהפכו fixed באותו רגע בדיוק. כל אחד
                מקבל left/right מפורשים משלו (לא אחוזים על גבי wrapper משותף)
                כדי שישארו זה-לצד-זה במקום להיערם/להידחס */}
            {(!mobiOrNot) ? (
                <>
                    <div className={`rstMnuRight ${restMnuFxClass}`}
                        style={getFixedElementStyle()}>
                        <div className={"fxPosWrap"} style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                            <Box sx={{ bgcolor: 'white', direction: 'rtl' }}>
                                <MenuList
                                    orientation={"vertical"}
                                    value={value}
                                    aria-label="תפריט"
                                >
                                    {
                                        props.buisMenu.map((item, index) => {
                                            if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {
                                                return (
                                                    <MenuItem key={index} onClick={() => handleChange(index)}
                                                        className={`tabClass ${(value == index) ? "selcedMnuIt" : ""}`}
                                                        style={{ color: "black" }} label={item.DivName}>{item.DivName}</MenuItem>
                                                )
                                            }
                                        })
                                    }
                                </MenuList>
                            </Box>
                        </div>
                    </div>

                    <div
                        ref={searchBarRef}
                        className={`serachOnMnu serachOnMnuDesktop ${restMnuFxClass}`}
                        style={getFixedElementStyle()}>
                        {searchTxt !== "" ? (
                            <div onClick={() => {
                                setSearchTxt("");
                                serachMnuItm("");
                            }}>
                                <HighlightOffIcon className="clearSrch" />
                            </div>
                        ) : (
                            ""
                        )}
                        <input
                            type={"text"}
                            placeholder={`חפש בתפריט של ${props.nameBuis}`}
                            value={searchTxt}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                setSearchTxt(newValue);

                                if (searchTimeoutRef.current) {
                                    clearTimeout(searchTimeoutRef.current);
                                }

                                searchTimeoutRef.current = setTimeout(() => {
                                    serachMnuItm(newValue);
                                }, 300);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    serachMnuItm(searchTxt);
                                }
                            }}
                        />
                        <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="חיפוש בעסק"
                            onClick={() => serachMnuItm(searchTxt)} />
                    </div>
                </>
            ) : (
                <div className={`tabsHeadPlace ${restMnuFxClass}`}>
                    {(searchTxt == "") ? <div className={"fxPosWrap"}>
                        <Box sx={{ bgcolor: 'white', direction: 'rtl' }}>
                            {(restMnuFxClass == "fixPos") ?
                                <>
                                    <h2 className={"headOnPFix bold SecondFontRegular big"}>
                                        {currP.buissName}
                                    </h2>
                                    <p className="onPhonePFix">{onlyPhoneOrders}</p>
                                </>
                                : ""}
                            <Tabs
                                value={value}
                                variant="scrollable"
                                scrollButtons={false}
                                aria-label="תפריט"
                            >
                                {
                                    props.buisMenu.map((item, index) => {

                                        if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {
                                            return (
                                                <Tab key={index}
                                                    onClick={() => handleChange(index)}
                                                    className={"tabClass"}
                                                    style={{ color: "black" }} label={item.DivName} />)
                                        }
                                    })
                                }
                            </Tabs>
                        </Box>
                    </div> : ""}

                    {/* שורת חיפוש - תמיד תופיע במובייל */}
                    <div className={"serachOnMnu"}>
                        {searchTxt !== "" ? (
                            <div onClick={() => serachMnuItm("")}>
                                <HighlightOffIcon className="clearSrch" />
                            </div>
                        ) : (
                            ""
                        )}
                        <input
                            type={"text"}
                            placeholder={`חפש בתפריט של ${props.nameBuis}`}
                            value={searchTxt}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                setSearchTxt(newValue);

                                // בטל טיימר קודם
                                if (searchTimeoutRef.current) {
                                    clearTimeout(searchTimeoutRef.current);
                                }

                                // החיפוש יתבצע רק 300ms אחרי שהמשתמש מפסיק להקליד
                                searchTimeoutRef.current = setTimeout(() => {
                                    serachMnuItm(newValue);
                                }, 300);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    serachMnuItm(searchTxt);
                                }
                            }}
                        />
                        <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="חיפוש בעסק"
                            onClick={() => serachMnuItm(searchTxt)} />
                    </div>
                </div>
            )}

            {/* שמאל בדסקטופ */}
            {
                (!mobiOrNot) ? <div className={"rstMnuLeft"}>
                    <div className={"rstMnuLeftIn fxPosWrap"}>
                        <div style={{ overflow: "hidden" }}>
                            <div className={"bold"}>פרטי המסעדה:</div>
                            <br />
                            <PhoneLink phone={props.restPage.buissPhone} className={"overFlHid"}>
                                <div className={"phoneLine"}>
                                    <div className="clickPhoneBtn">{getPhoneDisplay(props.restPage.buissPhone)}</div>
                                </div>
                            </PhoneLink>
                            {(props.restPage.buissAddress) ? <AddressLine address={props.restPage.buissAddress} /> : ""}
                            <DayOpeningHours item={props.restPage} />
                            {props.delTiming}
                            <BuisRating rating={props.restPage.buissRating} restId={props.restPage._id} />

                        </div>
                        <br />
                        <div className={"bold pointing"} onClick={() => props.showMoreDet()}>
                            <span>עוד פרטים</span>
                        </div>

                        <div className={"detailsLine moreDetBtn pointing"}>
                            {/* <div className={"bold"} onClick={() => props.setDispOnlyDelivery()}>
                                <span>{(props.dispOnlyDelivery) ? "הצג תפריט מלא" : "הצג תפריט משלוחים"} </span>
                            </div> */}
                        </div>
                    </div>
                </div> : ""
            }

            {/* תצוגת מוצרים */}
            <div className={`rstMnuWrap ${restMnuSpClass}`}>
                {(searchTxt == "") ?
                    <div className={`mnuDivs ${mnuDivsPadd}`}>
                        {

                            props.buisMenu.map((item, index) => {

                                if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {
                                    let divsBk = item.Products.map((divitm, divIndex) => {

                                        if (!props.dispOnlyDelivery || divitm.okToDeliver) {
                                            if (mobiOrNot) {
                                                return (
                                                    <ProductItem key={divitm._id}
                                                        dops={0} itemId={`${divIndex}_${index}`}
                                                        divitm={divitm}
                                                        doDeliver={props.doDeliver}
                                                        doTakeAway={props.doTakeAway}
                                                        setSender={(senderId) => setSender(senderId)}
                                                        sender={sender}
                                                        dispOnlyDelivery={props.dispOnlyDelivery}
                                                        onlyPhone={onlyPhone}
                                                        myClass={(!divitm.inStock) ? "outOfStock" : ""}
                                                    />
                                                )
                                            }
                                            else {
                                                return (
                                                    <ProductItem key={divitm._id}
                                                        dops={0} itemId={`${divIndex}_${index}`}
                                                        divitm={divitm}
                                                        doDeliver={props.doDeliver}
                                                        doTakeAway={props.doTakeAway}
                                                        setSender={(senderId) => setSender(senderId)}
                                                        sender={sender}
                                                        dispOnlyDelivery={props.dispOnlyDelivery}
                                                        onlyPhone={onlyPhone}
                                                        myClass={(!divitm.inStock) ? "outOfStock" : ""}
                                                    />
                                                )
                                            }
                                        }
                                    });

                                    let itmDesc = (item.DivDescript && item.DivDescript != "") ?
                                        <div className={`${(mobiOrNot) ? "width_90" : ""} mnuDivPrdcReg`}>
                                            {parse(item.DivDescript)}</div> : "";

                                    return (
                                        <div key={index} id={`divBlock_${index}`} className="">
                                            <h2 className={`divHead ${(mobiOrNot) ? "veryBig" : "anak"} bold SecondFont`}> {item.DivName}</h2>
                                            {itmDesc}
                                            <LazyProductList products={divsBk} preload={index === 0} />
                                        </div>
                                    )
                                }
                            })}
                    </div>
                    :
                    <div className={`mnuDivs ${mnuDivsPadd}`}>
                        {
                            props.buisMenu.map((item, index) => {

                                if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {
                                    var cnt = 0;
                                    let divsBk = item.Products.map((divitm, divIndex) => {

                                        const searchWords = searchTxt.toLowerCase().trim().split(/\s+/);
                                        const prodNameLower = divitm.prodName.toLowerCase();
                                        const matchesSearch = searchWords.every(word => prodNameLower.includes(word));

                                        if (matchesSearch) {
                                            cnt++;

                                            if (!props.dispOnlyDelivery || divitm.okToDeliver) {
                                                if (divitm.inStock) {
                                                    if (mobiOrNot) {
                                                        return (
                                                            <ProductItem key={divitm._id}
                                                                dops={0} itemId={`${divIndex}_${index}`}
                                                                divitm={divitm}
                                                                doDeliver={props.doDeliver}
                                                                doTakeAway={props.doTakeAway}
                                                                setSender={(senderId) => setSender(senderId)}
                                                                sender={sender}
                                                                dispOnlyDelivery={props.dispOnlyDelivery}
                                                                onlyPhone={onlyPhone} />
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <ProductItem key={divitm._id}
                                                                dops={0} itemId={`${divIndex}_${index}`}
                                                                divitm={divitm}
                                                                doDeliver={props.doDeliver}
                                                                doTakeAway={props.doTakeAway}
                                                                setSender={(senderId) => setSender(senderId)}
                                                                sender={sender}
                                                                dispOnlyDelivery={props.dispOnlyDelivery}
                                                                onlyPhone={onlyPhone}
                                                                myClass={(!divitm.inStock) ? "outOfStock" : ""}
                                                            />
                                                        )
                                                    }
                                                }
                                            }


                                        }
                                    });
                                    if (parseInt(cnt) > 0) {
                                        return <div key={index} id={`divBlock_${index}`} className="divBlock">
                                            <h2 className={"divHead veryBig bold SecondFont fullRow"}> {cnt.length}{item.DivName}</h2>
                                            {divsBk}
                                        </div>
                                    }
                                }
                            })}
                    </div>
                }
            </div>

        </div>

    );
}

export default RestMnu;